import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import AppModel from '../DataModel/AppModel';


export default
@observer class SelectHomeLocation extends Component {

  setHomeLocation(user) {
    return function(event, index, value) {
      user.id_home_location = value;
    }
  }

  parentChoices() {
    var list = [];
    if(AppModel.allowAddingRootLocations) {
      list.push( <MenuItem  key={"root"}
                            value={"root"}
                            primaryText={uiMsg('SHL_ALL_AREAS',"All areas.")}/>);
    }
    AppModel.parentLocationChoices.forEach(function(parentLocation) {
      list.push(
        <MenuItem key={parentLocation.id}
                  value={parentLocation.id}
                  primaryText={ parentLocation.indentStr +
                                parentLocation.typeName+": "+
                                parentLocation.name}/>)
    });
    return list;
  }

  render() {
    var user = this.props.user;
    return (
      <SelectField
          disabled={AppModel.id_user == user.id}
          floatingLabelText={uiMsg('SHL_AREA_USER_WORK_WITHIN',"Area user works within")}
          hintText={uiMsg('SHL_AREA_USER_WORK_WITHIN_HINT',"Limit user to select area")}
          value={user.id_home_location}
          fullWidth={true}
          onChange={this.setHomeLocation(user)}>
          {this.parentChoices()}
      </SelectField>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectHomeLocation.jsx
 **/